import { request } from '../../utility/services/request';
import { Service } from '../base';
import objectToFormData from '../../utility/Utils';
import axios from 'axios';

class CustomConstanciasService extends Service {

	create(values) {
		return request('POST', this.baseUrl, values, null, true);
	}

	get() {
		return request('GET', this.baseUrl);
	}

	update(id, values) {
		values['_method'] = 'PUT';
		return request('POST', `${this.baseUrl}/${id}`, values, null, true);
	}

}

export default CustomConstanciasService;
